<!-- 车辆管理-运营情况 -->

<template>
  <div class="operation-situation main-cnt">
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :apiName="VipApi.getOperationLists"
        :filters="filters" :columns="tableColumns" @onDetails="onDetails" @onCancel="onCancel">
        <template #status="{ row }">
          <div class="status-text" :class="refundStatusColors(row.status)">{{ row.status_text }}</div>
        </template>

        <!-- 修改 -->
        <template #edit="{ row }">
          <template
            v-if="(row.status == 1 || row.status == 2) && authData.indexOf('n_39866a6c0ecde97b77225e3f5') != -1">
            <el-button @click="onEditBtn(row)">修改</el-button>
          </template>
        </template>
      </common-table>
    </div>

    <!-- 详情 -->
    <OperationDetails ref="infoRef"></OperationDetails>

    <!-- 编辑 -->
    <OperationEditDetails ref="editRef" @submit="onSubmit"></OperationEditDetails>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, ElMessageBox, } from "element-plus";
import { useStore } from "vuex";
import OperationDetails from "../components/OperationDetails.vue";
import OperationEditDetails from "../components/OperationEditDetails.vue";

const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
/** 表格对象 */
const tableRef = ref(null);
/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "car_plate",
    label: "车辆",
  },
  {
    prop: "departure_place",
    prop2: "arrival_place",
    connectText: "-",
    type: "connect",
    label: "路线",
    minWidth: 200,
  },
  {
    prop: "departure_time",
    label: "发车时间",
    minWidth: 110,
  },
  {
    prop: "arrival_time",
    label: "预计抵达时间",
    minWidth: 110,
  },
  {
    prop: "stopover_place",
    label: "途经点",
  },
  {
    prop: "count",
    label: "乘车人数",
  },
  {
    prop: "available_count",
    label: "剩余座位",
    color: "--warning-color",
  },
  {
    prop: "driver_name",
    label: "司机",
  },
  {
    prop: "status",
    type: "customRender",
    label: "运行状态",
  },
  {
    prop: "contact_name",
    label: "约车人",
    minWidth: 150,
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 280,
    bottons: [
      {
        name: "详情",
        action: "onDetails",
        token: "n_9a3a784276397aae8ff360cda",
      },
      {
        name: "修改",
        action: "edit",
        type: "customRender",
      },
      {
        name: "取消派车",
        action: "onCancel",
        HiddenKey: "status",
        showValue: [1],
        token: "n_a89256d282e333b035e5338e3",
      },
    ],
  },
]);
const infoRef = ref(null);  // 详情对话框
const editRef = ref(null);  // 编辑对话框
/** 筛选条件列表 */
const filters = ref([
  {
    filterType: "search",
    name: "keyword",
    value: "",
    placeholder: "请输入车牌号、约车人姓名或手机号、途经点",
  },
  {
    filterType: "select",
    name: "status",
    value: "",
    placeholder: "请选择运营状态",
    options: [],
    val: "id",
    lab: "name",
  },
  {
    filterType: "date",
    name: "departure_time",
    value: [],
    placeholder: "请选择发车时间",
    type: "date",
  },
])

/**
 * 
 * 退款状态
 * 
 * **/
const refundStatusColors = (status) => {
  let status_color = '';
  switch (status) {
    case 1:
      status_color = 'btn-orange';
      break;
    case 2:
      status_color = 'btn-yellow';
      break;
    case 3:
      status_color = 'btn-blue';
      break;
    case 4:
      status_color = 'btn-grey';
      break;
  }

  return status_color;
}
/**
 * 
 * 获取运营状态
 * 
 * **/
const getStatusOptions = () => {
  VipApi.getCarRecordsStatus().then((res) => {
    if (res.Code == 200) {
      filters.value[1].options = res.Data;
    }
  });
}
/**
 * 
 * 详情按钮
 * 
 * **/
const onDetails = (row) => {
  infoRef.value.openDialog(row);
}
/**
 * 
 * 编辑按钮
 * 
 * **/
const onEditBtn = (row) => {
  editRef.value.openDialog(row);
}
/**
 * 
 * 编辑提交按钮
 * 
 * **/
const onSubmit = () => {
  tableRef.value.tableLoad();
}
/**
 * 
 * 取消派车按钮
 * 
 * **/
const onCancel = (row) => {
  ElMessageBox.confirm("确认取消本次派车，取消后若该派车记录关联了用户订单，订单将直接退款。", "取消派车确认", {
    confirmButtonText: "确认取消",
    cancelButtonText: "我在想想",
  })
    .then(() => {
      VipApi.cancelCarRecords({ id: row.id, }).then((res) => {
        if (res.Code == 200) {
          ElMessage.success("取消派车成功！");
          tableRef.value.tableLoad();
        } else {
          ElMessage.error(res.Message);
        }
      });
    })
    .catch(() => { });
}

onMounted(() => {
  getStatusOptions();
  tableRef.value.tableLoad();
});
</script>

<style lang="scss">
.operation-situation {
  font-family: "Source Han Sans CN";

  .content {
    padding: 15px 20px 20px;

    .search-input {
      width: 340px !important;
    }

    .el-date-editor {
      width: 192px !important;
    }
  }
}
</style>
